import { styled } from '@grupoboticario/flora'
import { ChevronDownIcon } from '@grupoboticario/flora-react-icons'

export const Wrapper = styled('div', {
  position: 'relative',
})

export const IconSelect = styled(ChevronDownIcon, {
  pointerEvents: 'none',
  position: 'absolute',
  right: '$2',
  top: '50%',
  transform: 'translateY(-50%)',
})

const selectColor = '$backgroundPrimary'

export const Select = styled('select', {
  appearance: 'none',
  background: 'transparent',
  borderColor: '$backgroundAltPrimary',
  borderRadius: '$small',
  borderStyle: 'solid',
  borderWidth: '$hairline',
  color: '$backgroundAltPrimary',
  fontFamily: '$primary',
  fontSize: 14,
  height: 48,
  lineHeight: '$normal',
  paddingLeft: '$4',
  paddingRight: '$8',
  width: '100%',

  variants: {
    isLight: {
      true: {
        borderColor: selectColor,
        color: '$nonInteractiveAltPredominant',
        '& option': {
          background: selectColor,
          color: '$nonInteractivePredominant',
        },
      },
    },
  },
})
